module.exports = __webpack_public_path__ + "img/38e2ef16a8dd4d7121b55be9c58caf55.png";